export enum ContentGroup {
	Dashboard = 'Dashboard',
	Customers = 'Customers',
	Users = 'Users (Admins)',
	Help = 'Help',
	Other = 'Other',
}

export const pushToDataLayer = (eventObj: object) => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ ...eventObj, url: window.location.href, path: window.location.pathname });
};
